// AddBarber.jsx
import React from "react";
import { useAddEditBarber } from "../../hooks/barber/useAddEditBarber";
import AlertMessage from "../../components/AlertMessage";

const AddEditBarber = ({ onCreated, barber, onClearbarber, sectionRef }) => {
  const {
    firstName,
    setFirstName,
    title,
    lastName,
    setLastName,
    phoneNumber,
    setPhoneNumber,
    email,
    setEmail,
    imagePreview,
    isSubmitting,
    showMessage,
    setShowMessage,
    message,
    fileInputRef,
    onFileChange,
    handleSubmit,
    clearForm,
  } = useAddEditBarber({ onCreated, barber, onClearbarber });
  return (
    <form
      onSubmit={handleSubmit}
      className="card p-3 shadow-sm"
      encType="multipart/form-data"
      ref={sectionRef}
    >
      <h5 className="mb-3">{title}</h5>
      {showMessage && (
        <AlertMessage
          key={message.text}
          setVisible={setShowMessage}
          message={message.text}
          type={message.type}
          duration={4000}
        />
      )}

      <div className="mb-3">
        <label className="form-label">First Name</label>
        <input
          type="text"
          className="form-control"
          value={firstName}
          onChange={(e) => setFirstName(e.target.value)}
          disabled={isSubmitting}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Last Name</label>
        <input
          type="text"
          className="form-control"
          value={lastName}
          onChange={(e) => setLastName(e.target.value)}
          disabled={isSubmitting}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Phone</label>
        <input
          type="tel"
          className="form-control"
          value={phoneNumber}
          onChange={(e) => setPhoneNumber(e.target.value)}
          disabled={isSubmitting}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Email</label>
        <input
          type="email"
          className="form-control"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          disabled={isSubmitting}
        />
      </div>

      <div className="mb-3">
        <label className="form-label">Photo (optional)</label>
        <input
          type="file"
          className="form-control"
          accept="image/*"
          onChange={onFileChange}
          disabled={isSubmitting}
          ref={fileInputRef}
        />
      </div>

      {imagePreview && (
        <div className="mb-3">
          <img
            src={imagePreview}
            alt="preview"
            className="img-thumbnail"
            style={{ maxWidth: "350px", maxHeight: "350px" }}
          />
        </div>
      )}
      <div className="d-flex justify-content-end modal-footer mt-4 mb-3">
        <button
          type="button"
          className="btn btn-secondary me-2"
          onClick={() => clearForm()}
        >
          Clear
        </button>{" "}
        <button
          type="submit"
          className="btn btn-primary"
          disabled={isSubmitting}
          onClick={(e) => handleSubmit(e)}
        >
          {isSubmitting ? "Saving..." : "Save"}
        </button>
      </div>
    </form>
  );
};

export default AddEditBarber;
